import React, { FC, useCallback } from 'react';
import classNames from 'classnames';
import styles from '../../index.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { Button } from 'src/common';
import { IKeyword, HighlightColorDict } from 'src/models/matchingProfiles/types';
import { useDeleteMPKeyword } from 'src/models/matchingProfiles/hooks';

interface IPreferencesKeywordsItemProps {
  keyword: IKeyword;
  disabled: boolean;
  mpId: string;
}

export const KeywordsItem: FC<IPreferencesKeywordsItemProps> = props => {
  const { keyword, disabled, mpId } = props;
  const { value: title, highlightColor, id } = keyword;

  const [deleteMPKeywords] = useDeleteMPKeyword();

  const onRemove = useCallback(() => {
    deleteMPKeywords(id, mpId);
  }, [deleteMPKeywords, id, mpId]);

  return (
    <li className={classNames(styles.keywordsItem, disabled ? styles.isDisabled : '')}>
      <span className={styles.keywordsItemInner} style={{ background: HighlightColorDict[highlightColor] }}>
        <span className={styles.keywordsItemTitle}>{title}</span>
        {!disabled && (
          <Button
            type={'text'}
            onClick={onRemove}
            icon={<FontAwesomeIcon icon={faTimes} />}
            className={styles.button}
          />
        )}
      </span>
    </li>
  );
};

export default KeywordsItem;
